import store from '@/store'
import whitelabel from '../../whitelabel.config'

export function hasSlug ({
  params
}) {
  return Boolean(params.slug)
}

export function hasValidSlug ({
  params
}) {
  return store.getters.getQuestions.some(({
    slug
  }) => slug === params.slug)
}

export function hasPreviousAnswer ({
  params
}) {
  const questions = store.getters.getQuestions
  const answers = store.state.Questions.answers

  const toQuestionIndex = questions.findIndex(({
    slug
  }) => slug === params.slug)
  if (!toQuestionIndex) return true

  const previousQuestionId = questions[toQuestionIndex - 1].questionId

  return Boolean(answers[previousQuestionId])
}

export function hasGuards () {
  return !store.state.Dev || !store.state.Dev.disableNavigationGuards
}

export function indexGuards (to, from, next) {
  const firstQuestionSlug = whitelabel[process.env.VUE_APP_BRAND].firstQuestionSlug
  if (to.query) {
    return next({ path: firstQuestionSlug, query: to.query })
  } else {
    return next(firstQuestionSlug)
  }
}

export function questionGuards (to, from, next) {
  if (!hasGuards()) return next()

  if (!hasSlug(to) ||
  !hasValidSlug(to) ||
  !hasPreviousAnswer(to)) return next('/')

  next()
}

export function postQuestionGuards (to, from, next) {
  if (!hasGuards()) return next()

  if (!store.getters.hasLastAnswer) return next('/')

  next()
}

export function pascalCase (slug) {
  const split = slug.split('-')
  const pascalSlug = split.map(item => item.charAt(0).toUpperCase() + item.slice(1)).join('')
  return pascalSlug
}

export function utagView (to, next) {
  if (!whitelabel[process.env.VUE_APP_BRAND].utag) {
    return next()
  }

  let pascalSlug
  if (to.params.slug) {
    pascalSlug = pascalCase(to.params.slug)
  } else {
    pascalSlug = pascalCase(to.name)
  }
  window.utag_data.page_name = pascalSlug

  if (typeof window.utag !== 'undefined') {
    window.utag.view(window.utag_data)
  }
  next()
}
